var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_projects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1221892,3.81225575 C10.6081057,3.29875357 11.2810406,3 12.0001739,3 C12.7361674,3 13.4238278,3.31294178 13.8491863,3.78593352 L20.0368779,9.47562102 C20.0732409,9.50905741 20.1063502,9.54397057 20.1363066,9.58010213 C20.6842111,10.1305946 21,10.8823465 21,11.6829375 L21,19.038625 C21,20.6695796 19.6976637,22 18.0800417,22 L5.92030608,22 C4.30293144,22 3,20.6694712 3,19.038625 L3,11.6829375 C3,10.8823852 3.31604912,10.1306183 3.86406687,9.58007171 C3.89401085,9.54395785 3.92710481,9.50906128 3.96344935,9.47563998 L10.1221892,3.81225575 Z M12.4329136,5.19529842 C12.3187854,5.0699564 12.1650627,5 12.0001739,5 C11.8352082,5 11.681279,5.07003504 11.5666875,5.19573626 L11.5045622,5.25813085 L5.41288968,10.8598421 C5.38445199,10.8926906 5.35333449,10.924463 5.31945941,10.9549567 C5.11801895,11.1362894 5,11.3976297 5,11.6829375 L5,19.038625 C5,19.5741755 5.41699221,20 5.92030608,20 L18.0800417,20 C18.583431,20 19,19.5744479 19,19.038625 L19,11.6829375 C19,11.3973516 18.8821077,11.1360903 18.6808884,10.9549567 C18.6468837,10.9243463 18.6156576,10.8924473 18.5871317,10.8594648 L12.4329136,5.19529842 Z M8.90476296,14 L15.7809615,14 C16.2807525,14 16.6857244,14.4049719 16.6857244,14.904763 C16.6857244,15.404554 16.2807525,15.8095259 15.7809615,15.8095259 L8.90476296,15.8095259 C8.4049719,15.8095259 8,15.404554 8,14.904763 C8,14.4049719 8.4049719,14 8.90476296,14 Z M13.904763,17 L16.4380993,17 C16.9378903,17 17.3428622,17.4049719 17.3428622,17.904763 C17.3428622,18.404554 16.9378903,18.8095259 16.4380993,18.8095259 L13.904763,18.8095259 C13.4049719,18.8095259 13,18.404554 13,17.904763 C13,17.4049719 13.4049719,17 13.904763,17 Z M7.90476296,11 L10.4380993,11 C10.9378903,11 11.3428622,11.4049719 11.3428622,11.904763 C11.3428622,12.404554 10.9378903,12.8095259 10.4380993,12.8095259 L7.90476296,12.8095259 C7.4049719,12.8095259 7,12.404554 7,11.904763 C7,11.4049719 7.4049719,11 7.90476296,11 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_projects",
    transform: "translate(-3.000000, -3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "holder",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    fill: "#4C4C4C",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProjects);
export default __webpack_public_path__ + "static/media/ic_projects.f49fbb09e0951e556a3ea36094c9021b.svg";
export { ForwardRef as ReactComponent };